import { combineReducers } from 'redux';

import { basic } from './basic.reducer';
import { signIn } from './signin.reducer';
import { sidebar } from './sidebar.reducer';
import { breadcrumbs } from './breadcrumbs.reducer';
import { gettingStarted } from './gettingStated.reducer';
import { launchPad } from './launchpad.reducer';
import { roles } from './roles.reducer';
import { logs } from './logs.reducer';
import { agents } from './agents.reducer';
import { policiesAuth } from './policiesAuth.reducer';
import { jitUsers } from './jitUsers.reducer';
import { licenseAllocation } from './licenseAllocation.reducer';
import { groups } from './groups.reducer';
import { appLibrary } from './appLibrary.reducer';
import { workflowRequests } from './workflowRequests.reducer';
import { listPageBar } from './listPageBar.reducer';
import { apiExplorer } from './apiExplorer.reducer';
import { users } from './users.reducer';
import { orgs } from './organizations.reducer';
import { myProfile } from './myProfile.reducer';
import { syncs } from './sync.reducer';
import { modal } from './modal.reducer';
import { organizationSelect } from './organizationSelect.reducer';
import { provisioningPolicies } from './provisioningPolicies.reducers';
import { snackbar } from './snackbar.reducer';
import { launch } from './launch.reducer';
import { inAppVideos } from './inAppVideos.reducer';

const rootReducer = combineReducers({
    basic,
    signIn,
    sidebar,
    breadcrumbs,
    gettingStarted,
    launchPad,
    roles,
    logs,
    agents,
    policiesAuth,
    jitUsers,
    licenseAllocation,
    groups,
    appLibrary,
    workflowRequests,
    listPageBar,
    apiExplorer,
    users,
    orgs,
    myProfile,
    syncs,
    modal,
    organizationSelect,
    provisioningPolicies,
    snackbar,
    launch,
    inAppVideos
});

export default rootReducer;
